export const TRANSLATION_GROUP_PLAYER_ACTIVITY = Symbol('admin-players.player-activity');
export const PLAYER_ACTIVITY_ROUTE = Symbol('player_activity');
